import { useState } from 'react';
import { BASE_URL, MN_TIMESHEET } from '@jobcost-monorepo/crud';
import { checkTokenValidity } from '@jobcost-monorepo/utils';
import ReportRsHeader from './Header';

export default function ReportRsPage() {
  const [isLoading, setIsLoading] = useState(false);

  const handleGenerate = async (
    year: number,
    percentage: number,
    projectName: string,
  ) => {
    setIsLoading(true);
    try {
      const token = await checkTokenValidity();

      const params = new URLSearchParams({
        year: year.toString(),
        percentage: percentage.toString(),
        projectName: projectName,
      });

      const url = `${BASE_URL}/${MN_TIMESHEET.toLowerCase()}/reportRs?${params.toString()}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to generate report');
      }

      // Get the blob from the response
      const blob = await response.blob();

      // Create download link
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `Report_RS_${year}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Error generating report:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col size-full">
      <div className="px-6 pt-6">
        <ReportRsHeader handleGenerate={handleGenerate} isLoading={isLoading} />
      </div>
      <div className="overflow-auto px-6 pt-6">
        <p className="text-gray-600">
          Genera il report Excel delle ore lavorate dai dipendenti per progetti
          R&S, Innovazione e Design.
        </p>
      </div>
    </div>
  );
}
